import React from "react";

function FlightBookingQueues() {
  return <div>FlightBookingQueues</div>;
}

export default FlightBookingQueues;
